export enum DamageListItemStateEnum {
    ALL = -1,
    // Same States as in DamageReportDamageStateEnum
    OPEN = 0,
    IN_PROGRESS = 1,
    FINISHED = 2,
    CANCELLED = 3
}